import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.4.106c-.3-.195-.8-.098-1.1.098L4.6 3.92H1c-.6 0-1 .39-1 .977v5.866c0 .586.4.978 1 .978h3.6l4.7 3.714c.2.098.4.196.6.196.1 0 .3 0 .4-.098.3-.196.6-.489.6-.88V.986c.1-.39-.1-.684-.5-.88M9 12.62 5.6 9.98c-.2-.097-.4-.195-.6-.195H2v-3.91h3c.2 0 .4-.098.6-.196L9 3.04z"
    }, null, -1)
  ]))]))
}
export default { render: render }